export default "__VITE_ASSET__mBQCm7ip__"